var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alerts-list"},_vm._l((_vm.alerts),function(alert){return _c('AlertMessage',{key:alert.id,attrs:{"alert":alert}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }